import { Component, Input } from '@angular/core';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { AddinView } from '@techwan/ionic-core';

@Component({
  templateUrl: 'unit-activity-editor.component.html',
  styleUrls: ['unit-activity-editor.component.scss']
})
@AddinView({
  name: 'UnitActivityEditor'
})
export class UnitActivityEditorComponent {
  @Input()
  unitActivity: UnitActivity;

  constructor() {}
}
